module.exports = __webpack_public_path__ + "static/img/104158.3194ced0.png";